import { useNavigate, useSearch } from "@tanstack/react-router";
import { useHandler } from "./useHandler";

export function useSettingsOpen() {
  const navigate = useNavigate();
  // @ts-expect-error - no idea why tsc wasn't complaining about this before
  const { settings = false } = useSearch({
    strict: false,
  });

  const setSettingsOpen = useHandler(
    (openOrUpdater: boolean | ((prev: boolean) => boolean)) => {
      const open =
        typeof openOrUpdater === "function"
          ? openOrUpdater(settings)
          : openOrUpdater;
      if (open === settings) {
        return;
      }

      navigate({
        to: ".",
        search: (value) => {
          // @ts-expect-error - no idea why tsc wasn't complaining about this before
          const { settings, ...rest } = value;
          if (open) {
            return {
              ...rest,
              settings: open,
            };
          }
          return rest;
        },
        replace: true,
      });
    },
  );

  return {
    settingsOpen: settings,
    setSettingsOpen,
  };
}
